import angular from 'angular';
import moment from 'moment';
import AuthService from '@/shared/services/AuthService';

angular
  .module('cxSettings')
  .controller('ShareItemDialogCtrl', [
    '$element',
    '$scope',
    'close',
    '$window',
    'type',
    'id',
    'itemName',
    'relationName',
    'flySvc',
    'appUrls',
    '$http',
    'dataCache',
    shareItemDialogCtrl,
  ]);

function shareItemDialogCtrl(
  $element,
  $scope,
  close,
  $window,
  type,
  id,
  itemName,
  relationName,
  flySvc,
  appUrls,
  $http,
  dataCache,
) {
  var vm = this;
  vm.itemName = itemName;
  vm.remark = '';
  vm.selectedUsers = [];
  vm.saving = false;
  vm.submit = function() {
    if (!vm.selectedUsers || vm.selectedUsers < 1) {
      vm.invalidUsers = true;
      return;
    }

    let notificationType;
    switch (type) {
      case 'task':
        notificationType = 1000;
        break;
      case 'document':
        notificationType = 1001;
        break;
      case 'relation':
        notificationType = 1002;
        break;
      default:
        return;
    }

    const model = {
      shareMessage: vm.remark,
      shareSubject: relationName ? `${relationName} - ${itemName}` : itemName,
      level: 0,
      notificationType,
      objectId: id,
      recipients: vm.selectedUsers.map(x => ({
        userId: x,
        email: dataCache
          .getArray('user')
          .filter(x => x.isActive)
          .find(y => y.userID == x).email,
        languageCode: dataCache
          .getArray('user')
          .filter(x => x.isActive)
          .find(y => y.userID == x).languageCode,
      })),
    };
    vm.saving = true;
    return $http.post(`${appUrls.notifications}/api/notifications/createshare`, model).then(
      () => {
        vm.saving = false;
        flySvc.success('ItemWasShared');
        $element.modal('hide');
        close(vm.model, 500);
        return true;
      },
      error => {
        vm.saving = false;
        flySvc.error(error);
        console.error(error);
        return false;
      },
    );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
